module.exports = __webpack_public_path__ + "img/111.2274412a.jpg";